module.exports = __webpack_public_path__ + "static/su-a8e7bb46bbe1756ba38965c01f21ba7b.jpg";